import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Safety Tips",
    date: "20 April, 2025",
    admin: "Admin",
    heading: "Common Causes And Prevention Of House Fires",
    important: {
      content: "Effectively preventing house fires requires a combination of awareness, preparedness, and adherence to fire safety guidelines. Explore this guide to enhance your understanding of common fire hazards and protect your home and family.",
      intro: "Fire Safety Expert"
    },
    paragraph: {
      para1: "Explore the common causes of house fires and effective prevention strategies to safeguard your home and loved ones. Understanding key fire safety principles, implementing preventative measures, and staying informed are crucial steps in minimizing the risk of house fires.",
      para2: "Learn about the importance of smoke detectors, fire extinguisher placement, and emergency evacuation plans to enhance your home's fire safety.",
      para3: "Learn about the importance of electrical safety, kitchen fire prevention, and safe heating practices to ensure a fire-resistant living environment.",
      para4: "Visualize the various fire safety strategies and prevention techniques discussed in the guide through our gallery. Gain insights into real-life scenarios, preventative measures, and the importance of fire safety education."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Fire", "Prevention", "Safety"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Benjamin Alexander",
        date: "31 Dec, 2023",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Isabella Grace",
            date: "31 Dec, 2023",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Samuel James",
        date: "01 Jan, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Training Methods",
    date: "13 April, 2025",
    admin: "Admin",
    heading: "Physical Fitness for Firefighters",
    important: {
      content: "Maintaining peak physical fitness is crucial for firefighters to perform their duties effectively and safely. This guide explores essential training methods, conditioning strategies, and wellness practices tailored for the demands of firefighting.",
      intro: "Firefighter Wellness Coach"
    },
    paragraph: {
      para1: "Firefighting is a physically demanding profession that requires strength, endurance, and agility. This guide covers the importance of fitness for operational readiness, injury prevention, and mental resilience.",
      para2: "Learn about customized workout routines, cardiovascular training, strength conditioning, and mobility exercises specifically designed for firefighters.",
      para3: "Discover the role of proper nutrition, hydration, and rest in sustaining high performance and supporting recovery in emergency service professionals.",
      para4: "View real-world training scenarios and fitness strategies through our gallery. These visuals offer inspiration and guidance to build a strong, capable fire service workforce."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Fitness", "Firefighters", "Health"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Jordan Mitchell",
        date: "31 Dec, 2023",
        content: "This guide is exactly what our team needed! Staying fit is a non-negotiable part of the job.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Taylor Morgan",
            date: "31 Dec, 2023",
            content: "Absolutely agree. The section on mobility and injury prevention was really helpful."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Alex Carter",
        date: "01 Jan, 2025",
        content: "Practical, well-written, and relevant. Every fire department should read this."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Community Events",
    date: "04 April, 2025",
    admin: "Admin",
    heading: "Meet and Greet With Local Firefighters",
    important: {
      content: "Strengthening community ties starts with open communication and connection. Join us as we highlight a recent meet-and-greet event where residents got to interact with the brave men and women behind the uniform.",
      intro: "Community Outreach Coordinator"
    },
    paragraph: {
      para1: "This event offered families, students, and residents a chance to learn about the life of a firefighter, ask questions, and explore firefighting equipment up close.",
      para2: "Interactive demos, fire truck tours, and educational talks made the day fun and informative, while also spreading critical fire safety knowledge.",
      para3: "Our firefighters shared real-life stories, safety advice, and career insights, helping to foster respect and appreciation for emergency services.",
      para4: "Browse through our event gallery to relive the heartwarming moments, smiling faces, and powerful connections formed during this unforgettable day."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Community", "Firefighters", "Safety"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Emily Dawson",
        date: "16 Feb, 2025",
        content: "My kids had such a great time! They haven't stopped talking about the fire truck tour.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Chief Ryan",
            date: "16 Feb, 2025",
            content: "So glad to hear that! It was an honor having your family with us."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Liam Parker",
        date: "17 Feb, 2025",
        content: "Events like this really help build trust between the department and the community. Kudos!"
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Tech Advancements",
    date: "25 March, 2025",
    admin: "Admin",
    heading: "Drones Usage in Firefighting Work",
    important: {
      content: "The integration of drone technology into firefighting is revolutionizing emergency response. From aerial surveillance to search-and-rescue operations, drones provide critical support in enhancing safety and operational efficiency.",
      intro: "Tech & Safety Analyst"
    },
    paragraph: {
      para1: "Modern firefighting increasingly relies on drones for real-time situational awareness, especially in large-scale wildfires and inaccessible urban zones.",
      para2: "Drones equipped with thermal imaging cameras assist in locating hotspots, monitoring structural integrity, and identifying victims in low-visibility conditions.",
      para3: "They also reduce risk to personnel by offering reconnaissance before entry, and enable faster, more informed decision-making during emergencies.",
      para4: "Explore our gallery to see how drone tech is being used in live firefighting scenarios, and how departments are training teams to operate UAVs safely and effectively."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Drones", "Technology", "Fire"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Olivia Nguyen",
        date: "12 Mar, 2025",
        content: "This is the future of firefighting. Technology like this will save lives and time.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "TechFire Support",
            date: "12 Mar, 2025",
            content: "Absolutely. We're seeing more departments adopt drones every year."
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Noah Thompson",
        date: "13 Mar, 2025",
        content: "Loved the thermal imaging example. Would be great to see drone training workshops too!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Behind The Scenes",
    date: "15 March, 2025",
    admin: "Admin",
    heading: "Challenges and Triumphs from the Fire Station",
    important: {
      content: "Firefighters face physical, mental, and emotional challenges daily, yet their resilience and teamwork turn trials into triumphs. This piece offers a behind-the-scenes look at life inside the fire station—from high-pressure calls to heartwarming saves.",
      intro: "Station Lieutenant"
    },
    paragraph: {
      para1: "Every shift at the fire station brings unpredictability. From intense emergency calls to long overnight watches, firefighters rely on preparation, trust, and quick thinking.",
      para2: "This article shares powerful real-life accounts from crew members who’ve faced everything from raging house fires to complex rescue missions.",
      para3: "It also explores the mental health support systems, camaraderie, and leadership practices that help firefighters stay strong through difficult times.",
      para4: "Take a glimpse into station life with our gallery of moments—both heroic and human—that define the brotherhood and sisterhood of firefighting."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Firefighters", "Fire", "Community"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Maya Thompson",
        date: "29 Mar, 2025",
        content: "Incredible stories. Thank you for showing the strength and heart behind the uniform.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Captain Lewis",
            date: "29 Mar, 2025",
            content: "We appreciate your kind words. It's a privilege to serve this community."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "David Reed",
        date: "30 Mar, 2025",
        content: "Powerful read. More people need to understand the emotional side of the job too."
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Safety Tips",
    date: "07 March, 2025",
    admin: "Admin",
    heading: "Fire Safety in High-Rise Buildings",
    important: {
      content: "High-rise buildings present unique fire safety challenges. Understanding evacuation protocols, fire suppression systems, and resident responsibilities is key to preventing tragedies and ensuring swift emergency response.",
      intro: "Urban Fire Safety Specialist"
    },
    paragraph: {
      para1: "Fires in high-rise buildings can escalate quickly due to vertical design, population density, and limited access points for responders. Preparedness is critical.",
      para2: "This article discusses essential fire safety systems like sprinklers, smoke alarms, pressurized stairwells, and communication tools built into high-rise infrastructure.",
      para3: "We also provide practical advice for residents, including fire escape planning, understanding alarm systems, and what to do if trapped inside during an emergency.",
      para4: "See our gallery for diagrams, real incident responses, and building walkthroughs that illustrate fire safety best practices in tall structures."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Safety", "Prevention", "Fire"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Claire Bennett",
        date: "06 Apr, 2025",
        content: "Living in a high-rise, this info is so relevant. Everyone in my building needs to read this!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Deputy Chief Harris",
            date: "06 Apr, 2025",
            content: "Glad it helped! High-rise safety is a team effort—residents and departments alike."
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Rafael Kim",
        date: "07 Apr, 2025",
        content: "Super informative. I’ll be revisiting our emergency plan with my family tonight."
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Safety Tips",
    date: "01 March, 2025",
    admin: "Admin",
    heading: "House Fire Risks and Prevention Methods",
    important: {
      content: "Understanding the leading causes of house fires and how to prevent them is the first step to protecting your home and loved ones. This guide covers everything from electrical safety to emergency preparedness.",
      intro: "Home Safety Specialist"
    },
    paragraph: {
      para1: "House fires can ignite in an instant—commonly triggered by cooking mishaps, electrical malfunctions, unattended candles, or heating equipment.",
      para2: "This blog outlines top fire hazards inside a home and offers actionable tips like proper outlet use, safe appliance practices, and maintaining fire alarms.",
      para3: "We also emphasize the importance of fire escape planning, family drills, and accessible fire extinguishers to ensure readiness when seconds count.",
      para4: "Browse our gallery for helpful visuals on fire prevention setups, real-case scenarios, and steps to make your home more fire-resilient."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Prevention", "Fire", "Safety"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Ava Martin",
        date: "13 Apr, 2025",
        content: "This is so helpful! I didn’t realize how many common appliances could be a risk. Thank you for this!"
      },
      {
        id: 2,
        image: images.blog7Comment2,
        name: "Jordan Cruz",
        date: "13 Apr, 2025",
        content: "The fire escape planning part really hit home—definitely sharing this with my neighborhood group."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Training Methods",
    date: "28 February, 2025",
    admin: "Admin",
    heading: "Enhancing Firefighter Fitness and Health",
    important: {
      content: "A firefighter’s job demands peak physical and mental fitness. This guide explores training routines, recovery strategies, and nutrition tips tailored to the unique challenges firefighters face on and off duty.",
      intro: "Fire Department Wellness Coach"
    },
    paragraph: {
      para1: "Firefighters face intense physical and emotional demands that require consistent training, injury prevention, and health monitoring to maintain peak performance.",
      para2: "This article breaks down essential fitness components—strength, endurance, flexibility—and how they tie into job-specific tasks like gear hauling, rescues, and sustained exertion.",
      para3: "It also explores nutrition, mental health awareness, sleep habits, and access to support programs that help firefighters stay resilient and ready.",
      para4: "Dive into our gallery showcasing fitness sessions, health checkups, and real-life examples of how departments are investing in firefighter wellness."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Fitness", "Firefighters", "Health"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Emily Rivera",
        date: "16 Apr, 2025",
        content: "Love this focus on health. Firefighters give so much—they deserve this kind of support.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Wellness Officer Grant",
            date: "16 Apr, 2025",
            content: "Thank you, Emily! We're working to make health a core part of the culture."
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Mark Daniels",
        date: "17 Apr, 2025",
        content: "Would be great to see this kind of initiative in every department. Great read!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Community Events",
    date: "18 February, 2025",
    admin: "Admin",
    heading: "Connecting with Local Firefighters",
    important: {
      content: "Building strong community bonds starts with meeting the heroes who protect us. Discover how local fire departments foster trust and awareness through public events, school visits, and open house experiences.",
      intro: "Community Liaison Officer"
    },
    paragraph: {
      para1: "Firefighters aren't just first responders—they’re community educators, role models, and everyday heroes who thrive on community interaction.",
      para2: "This article explores how departments organize open houses, school visits, safety workshops, and station tours to help citizens of all ages connect with their local firefighters.",
      para3: "We also cover how these interactions help build trust, boost fire safety awareness, and inspire the next generation of firefighters.",
      para4: "Take a visual journey through our gallery highlighting meet-and-greet events, fire truck demos, and memorable moments between crews and the community."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Community", "Firefighters", "Safety"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Liam Foster",
        date: "18 Apr, 2025",
        content: "My kids still talk about the time they toured the station! Love this initiative."
      },
      {
        id: 2,
        image: images.blog9Comment2,
        name: "Nina Kapoor",
        date: "19 Apr, 2025",
        content: "It’s amazing how approachable and kind our firefighters are. These events matter!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Tech Advancements",
    date: "03 February, 2025",
    admin: "Admin",
    heading: "The Role of Drones in Modern Firefighting",
    important: {
      content: "Drones have transformed how fire departments respond to emergencies. From aerial surveillance to thermal imaging, explore how unmanned aerial systems are becoming essential tools in modern firefighting.",
      intro: "Tech Operations Chief"
    },
    paragraph: {
      para1: "In critical situations, drones provide real-time insights that help firefighters strategize faster and safer. They offer bird’s-eye views of fire spread, terrain, and structural threats.",
      para2: "Modern fire departments now use drones for search and rescue, post-incident assessment, and hazardous material detection with the help of thermal and infrared sensors.",
      para3: "We also discuss FAA regulations, pilot training, and the ethical considerations surrounding drone usage in public safety.",
      para4: "Explore our gallery of drone deployments in live operations and training sessions to see this powerful tech in action."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Drones", "Technology", "Fire"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Maya Stevens",
        date: "20 Apr, 2025",
        content: "Incredible to see how technology is making firefighting smarter and safer!"
      },
      {
        id: 2,
        image: images.blog10Comment2,
        name: "Greg Holloway",
        date: "21 Apr, 2025",
        content: "Would love to see a live demo someday. Amazing potential."
      }
    ]
  }

];

export default blogs;